module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-300.e7a891b0.woff";